import clone from 'lodash/clone';

import workspace from "../core/workspace";
import {
  MOVABLE_IMAGE_TYPES,
  SHAPE_PART_ID,
} from "../../../constants";
import sqftShape from "../core/shapes/sqftShape";
import ShapeHelper, {getBacksplashFeatureGroup} from "../../../helpers/shapeHelper";
import sqftShapeManager from "./sqftShapeManager";
import sqftSlabManager from "./sqftSlabManager";
import {renderErrorPopup} from "../../../../../api/api-popups";
import MovableImage from "../core/shapes/movableImage";
import SlabWorkspace from "../core/slab/slabWorkspace";
import sqftSeamShapesManager from "./sqftSeamShapesManager";
import CountertopSwitchers from "../../../../kvComponent/navigation/countertopSwitchers";

const sqftShapeIntersectionsManager = {
  resetShapesIntersections() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        shape.shapeIntersections.setOverlappedWithShapeIds([]);
      }
    }
  },
  updateShapesIntersections() {
    this.resetShapesIntersections();

    const shapes = workspace.getShapes();
    //console.log("----------------------");
    for (const shape of shapes) {
      if (shape instanceof sqftShape || shape instanceof MovableImage) {
        for (const testShape of shapes) {
          if ((testShape instanceof sqftShape || testShape instanceof MovableImage)
            && shape.id !== testShape.id
          ) {
            const shapeIntersections = ShapeHelper.getTwoShapesIntersections(shape, testShape);
            const shapeIds = Object.keys(shapeIntersections);
            if (shapeIds.length) {
              shape.shapeIntersections.addOverlappedWithShape(+shapeIds[0]);
            } else if (ShapeHelper.checkIfShapeContainsAnother(shape, testShape)) {
              //console.log("shapeId", shape.id);
              //console.log("testShapeId", testShape.id);
              testShape.shapeIntersections.addOverlappedWithShape(shape.id);
              shape.shapeIntersections.addOverlappedWithShape(testShape.id);
            }
          }
        }
        //console.log("shapeId", shape.id);
        //console.log("shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
      }
    }
    //this.logShapeFeatureIds()
  },
  logShapeFeatureIds() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      console.log("shape id", shape.id);
      console.log("shape feature id", shape.featureId);
      console.log("shape shapeIntersections overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
    }
  },
  logSnappedShapeGroups() {
    const shapes = workspace.getShapes();
    console.log("------");
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        console.log("shape id", shape.id);
        console.log("shape area", shape.getTotalArea());
        console.log("shape getSnappedShapeGroup", shape.shapeAbsolute.getSnappedShapeGroup());
        console.log("shape shapeSlab getSnappedShapeGroup", shape.shapeSlab.shapeAbsolute.getSnappedShapeGroup());
      }
    }
    console.log("------");
  },
  updateSlabPlaceholderFeatureId() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape
        && shape.partId === SHAPE_PART_ID.slabPlaceHolder
      ) {
        //console.log("update feature shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
        if (shape.shapeIntersections.overlappedWithShapeIds.length >= 1) {
          const intersectedShape = sqftShapeManager.getShapeById(shape.shapeIntersections.overlappedWithShapeIds[0]);
          shape.setFeatureId(clone(intersectedShape.featureId));
          shape.setSlabParentPartId(clone(intersectedShape.slabParentPartId ? intersectedShape.slabParentPartId : intersectedShape.partId));
        }
      }
    }
  },
  updateShapesFeaturePlacedOnSlabImages() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        //console.log("update feature shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
        if (shape.shapeIntersections.overlappedWithShapeIds.length >= 1) {
          const intersectedShape = sqftShapeManager.getShapeById(shape.shapeIntersections.overlappedWithShapeIds[0]);
          if (intersectedShape?.getFeature()?.getMatchingFeatureName() !== shape.getFeature()?.getMatchingFeatureName()) {

            //set feature for additional shapes
            let slabAdditionalShape = SlabWorkspace.slabAdditionalShapes.findOneByBacksplashShapeId(shape.id);
            if (slabAdditionalShape) {
              const backsplashFeatureGroup = getBacksplashFeatureGroup();
              let neededFeature = CountertopSwitchers.getNeededFeatureFromNavItems(intersectedShape.getFeature(), backsplashFeatureGroup ?? shape.getFeature()?.getParent());
              //console.log("backsplashFeatureGroup", backsplashFeatureGroup);
              //console.log("neededFeature", neededFeature);
              if (neededFeature) {
                slabAdditionalShape.line.setBacksplashFeatureId(neededFeature?.part?.dbFeature?.id);
              }
            }

            if (intersectedShape.type === MOVABLE_IMAGE_TYPES.slabImage) {
              //set feature for shape pieces
              sqftSeamShapesManager.syncFeatureToSeamedShapes(shape, intersectedShape.featureId)

              //set feature for the shape
              shape.setFeatureId(clone(intersectedShape.featureId));
              shape.setSlabParentPartId(clone(intersectedShape.slabParentPartId ? intersectedShape.slabParentPartId : intersectedShape.partId));
            }
          }
        }
      }
    }
  },

  showSlabPlaceHolderErrorMessage (
    slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes(),
    callback = new Function()
  ) {
    for (const slabPlaceHolderShape of slabPlaceHolderShapes) {
      //console.log("slabPlaceHolderShape.overlappedWithShapeIds", slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds);
      if (slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds.length >= 2) {
        const shapes = sqftShapeManager.getShapeByIds(slabPlaceHolderShape.shapeIntersections.overlappedWithShapeIds);
        if (
          !sqftShapeManager.hasSameSharedFeatureName(shapes)
          && !sqftShapeManager.hasSameFeatureId(shapes)
        ) {

          renderErrorPopup(workspace.intl.formatMessage({id: "sqft.popup.system.slabPlaceholderMultipleOverlap"}));
          callback();
        }
      }
    }
  }
};

export default sqftShapeIntersectionsManager
